<div class="height-100 bg-col-w p-t-15 p-t-6-s p-t-6-m">
    <div class="height-100 flex-column">

        <ng-container *ifSize="'!S'">
            <ng-container *ngTemplateOutlet="body"></ng-container>
        </ng-container>

        <div *ifSize="'S'"
             class="flex-grow flex-column overflow-y-scroll custom-scrollbar">
            <ng-container *ngTemplateOutlet="body"></ng-container>
        </div>

        <div class="w-12 p-l-10 p-r-10 p-b-10 p-t-5 p-r-4-s p-l-4-s"
             style="box-shadow: 0px 0px 4px rgba(33,33,33,0.15)">
            <div class="m-b-5"
                 [grid]="limit"
                 [gridColumnGap]="['6px','6px','8px','8px'][client.sizeId]">
                @for (slot of slots; track slot; let index = $index) {
                <div [ngClass]="isNextSlot(index) ? 'b-col-11 b-w-2' : 'b-col-4'"
                     class="ratio-1-1 b-radius-max b-a overflow-hidden">
                    @if (selectedSamples[index]) {
                    <img class="rf"
                         style="transform: scale(1.5)"
                         [image]="selectedSamples[index].product?.data?.image">
                    }
                </div>
                }
            </div>
            <action class="button w-12"
                    (click)="submit()"
                    [status]="status">
                <span>{{'Order Samples' | translate}}</span>
            </action>
            <result [status]="status"
                    class="block"></result>
            <form #form="ngForm"
                  method="post">

                <input-wrap [messages]="{required: 'Please select at least 1 sample'}">
                    <input type="hidden"
                           [(ngModel)]="valid"
                           name="samples"
                           required>
                </input-wrap>
            </form>
        </div>
    </div>
</div>

<ng-template #body>
    <div class="p-l-10 p-r-10 p-r-4-s p-l-4-s">
        <div class="flex flex-middle flex-justify-between">
            <h6 class="h3">
                {{content?.title || 'Free Samples'}}
            </h6>

            <button class="bg-col-5 b-radius-max pos-relative ratio-1-1"
                    [style.width.rem]="2.5"
                    role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="flex flex-middle flex-justify-center top-0 left-0 right-0 bottom-0 pos-absolute icon-close"
                   style="font-size: 0.875em"
                   aria-hidden="true"></i>
            </button>
        </div>
        @if (content?.text) {
        <p class="m-t-8 m-t-7-s p1 col-11">
            {{content.text}}
        </p>
        }
    </div>
    <div class="m-t-8 m-t-7-s flex-grow p-l-10 p-r-10 p-r-4-s p-l-4-s p-b-10 p-b-4-s"
         sizeClass="!S: overflow-y-scroll custom-scrollbar">
        @for (item of items; track trackBySampleFabric($index, item); let isFirst = $first) {
        <div [ngClass]="{'m-t-7' : !isFirst}">
            @if (item.title) {
            <h4 class="h4 m-b-5">{{item.title}}</h4>
            }
            <div [grid]="3"
                 [gridColumnGap]="['16px','16px','20px','20px'][client.sizeId]"
                 [gridRowGap]="['16px','16px','20px','20px'][client.sizeId]">
                @for (product of item.products; track trackBySampleId($index, product)) {
                <product-view-samples-modal-item [gridColumn]="1"
                                                 [item]="product"></product-view-samples-modal-item>
                }
            </div>
        </div>
        }
    </div>
</ng-template>